import { currency } from '../Currency/Currency';
import { formatDate } from '../FormatDate/FormatDate';
import { formatDateTime } from '../FormatDateTime/FormatDateTime';
import { parsePrice } from '../ParsePrice/ParsePrice';

export const renderByType = (type: string, length?: number) => (value: any) => {
  switch (`${type}`.toLowerCase()) {
    case 'currency' :
      return currency(value);
    case 'date' :
      return formatDate(value);
    case 'datetime' :
      return formatDateTime(value);
    case 'boolean' :
      return !!value ? 'Ja' : 'Nein';
    case 'price' :
      return !!value ? `${parsePrice(`${(value || 0)}`)} €` : '';
    default : break;
  }

  if(length) {
    return `${value}`.length > length ? `${value}`.substring(0, length) + '...' : value;
  }

  return value;
}
